import { Controller } from '@hotwired/stimulus'

export default class RebrandingUsersConfigurationsTermsFormController extends Controller {
  static targets = ['submitButton'];

  updateSubmitButton(event) {
    event.stopPropagation();

    const isChecked = event.target.checked;

    this.submitButtonTarget.disabled = !isChecked;
  }
}
